import Viewport from "flow/Viewport";
import MyFlow from "flow/MyFlow";

function createViewport(myFlow: MyFlow) {
    return new Viewport(myFlow);
}

export default {
    createViewport: createViewport
};
